<template>
  <div>
    <v-btn
      :loading="isLoading"
      depressed
      block
      @click="$refs.input.click()"
      v-text="'Загрузить'"
    />

    <input
      v-show="false"
      ref="input"
      :accept="accept"
      type="file"
      @input="uploadFile"
    >
  </div>
</template>

<script>
import { FilesApi } from '@/api/resources'
import { FILE_TAG_PUBLICATION } from '@/helpers/enums/params'

export default {
  name: 'BEditorFileUpload',
  inheritAttrs: false,
  props: {
    accept: String,
    tag: {
      type: String,
      required: true,
    },
    emitFull: Boolean,
  },
  data: () => ({
    isLoading: false,
    value: void 0,
  }),
  methods: {
    async uploadFile(e) {
      const api = new FilesApi()
      this.isLoading = true

      let response
      const file = e.target.files[0]

      try {
        response = await api.upload(file)

        const form = {
          name: file.name,
          raw_file_id: response.data.id,
          tags: [
            FILE_TAG_PUBLICATION,
            this.tag,
          ],
        }

        response = await api.create(form)

        const { data } = await api.getOne(response.data.id)

        this.value = data.raw_file
        this.$emit('input', this.emitFull ? data : this.value)

        return this.value
      } catch (error) {
        this.$notice.errors(error)
        return Promise.reject(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
